// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --safe-area-inset-bottom: calc(
    100vh - var(--tg-viewport-stable-height, 100vh)
  );
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif !important;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  line-height: 1;
}

html {
  font-size: 62.5%;
}

body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-size: 1.6rem;
  background: rgb(247, 246, 255);
  width: 100vw;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow-x: hidden;
  overflow-y: auto;
}

[tabindex="-1"]:focus {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-weight: normal;
}

p {
  margin: 0;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ul {
  list-style-type: none;
  padding: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-left: 0;
}

b,
strong {
  font-weight: bolder;
}

a {
  color: #8492a5;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: white;
  text-decoration: none;
}

a:not([href]):not([tabindex]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([tabindex]):focus {
  outline: 0;
}

pre,
code,
kbd,
samp {
  font-family: "Ubuntu";
  font-size: 1em;
}

pre {
  margin-top: 0;
  overflow: auto;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
  width: 100%;
  height: 100%;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6c757d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

button,
input[type=submit],
input[type=reset] {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: none;
}

body:has(input[type=radio]:focus:not(:focus-visible)),
body:has(input[type=radio]:focus:not(:focus-visible)) span,
body:has(input[type=checkbox]:focus:not(:focus-visible)),
button:focus {
  outline: none;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAEA;EACE;;GAAA;AAEF;;AAGA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,gDAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;EACA,cAAA;AAAF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;EACA,iBAAA;EACA,8BAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AACF;;AAEA;;;;;;EAME,SAAA;EACA,UAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAIA;;EAEE,0BAAA;EACA,yCAAA;EACA,iCAAA;EACA,YAAA;EAGA,8BAAA;AAFF;;AAKA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,qBAAA;EACA,UAAA;AAFF;;AAIA;EACE,gBAAA;AADF;;AAIA;EAEE,cAAA;AAFF;;AASA;;EAEE,mBAAA;AANF;;AASA;EACE,cAAA;EACA,qBAAA;EACA,6BAAA;AANF;;AASA;EACE,YAAA;EACA,qBAAA;AANF;;AASA;EACE,cAAA;EACA,qBAAA;AANF;;AASA;;EAEE,cAAA;EACA,qBAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;;;;EAIE,qBAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;EAEA,cAAA;AAPF;;AAcA;EACE,sBAAA;EACA,kBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAXF;;AAcA;EACE,yBAAA;AAXF;;AAcA;EACE,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;AAXF;;AAcA;EACE,mBAAA;AAXF;;AAcA;EACE,gBAAA;AAXF;;AAcA;EACE,mBAAA;EACA,0CAAA;AAXF;;AAcA;;;EAGE,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;AAXF;;AAaA;;;;EAIE,aAAA;AAVF;;AAaA;;;;;EAKE,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AAVF;;AAaA;;EAEE,iBAAA;AAVF;;AAaA;;EAEE,oBAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;;;;EAIE,0BAAA;AAVF;;AAaA;;;;EAIE,eAAA;AAVF;;AAaA;;;;EAIE,UAAA;EACA,kBAAA;AAVF;;AAaA;;EAEE,sBAAA;EACA,UAAA;AAVF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');\n\n:root {\n  --safe-area-inset-bottom: calc(\n    100vh - var(--tg-viewport-stable-height, 100vh)\n  );\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Montserrat', sans-serif !important;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  line-height: 1;\n}\nhtml {\n  font-size: 62.5%;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-size: 1.6rem;\n  background: rgba(247, 246, 255, 1);\n  width: 100vw;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n[tabindex='-1']:focus {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n  font-weight: normal;\n}\n\np {\n  margin: 0;\n  //margin-top: 0;\n  //margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n  text-decoration: underline dotted;\n  cursor: help;\n  //border-bottom: 0;\n  -webkit-text-decoration-skip-ink: none;\n  text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nul {\n  list-style-type: none;\n  padding: 0;\n}\ndt {\n  font-weight: 700;\n}\n\ndd {\n  //margin-bottom: 0.5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  //margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\na {\n  color: #8492a5;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na:hover {\n  color: white;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):hover,\na:not([href]):not([tabindex]):focus {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([tabindex]):focus {\n  outline: 0;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: 'Ubuntu';\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  //margin-bottom: 1rem;\n  overflow: auto;\n}\n\nfigure {\n  //margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #6c757d;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\nbutton,\ninput[type='submit'],\ninput[type='reset'] {\n  background: none;\n  color: inherit;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  outline: none;\n}\nbody:has(input[type='radio']:focus:not(:focus-visible)),\nbody:has(input[type='radio']:focus:not(:focus-visible)) span,\nbody:has(input[type='checkbox']:focus:not(:focus-visible)),\nbutton:focus {\n  outline: none;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type='button'],\n[type='reset'],\n[type='submit'] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type='button']:not(:disabled),\n[type='reset']:not(:disabled),\n[type='submit']:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type='button']::-moz-focus-inner,\n[type='reset']::-moz-focus-inner,\n[type='submit']::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type='radio'],\ninput[type='checkbox'] {\n  box-sizing: border-box;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
